import type {ReactElement} from 'react';
import {useState} from 'react';
import {ShareInTeamToggleBar} from '@Components/share-in-team-toggle-bar/share-in-team-toggle-bar';
import {ShareInTeamBarState} from '@Components/share-in-team-toggle-bar/share-in-team-toggle-bar.types';
import {shareEmailSignupFormInTeam} from '@Libraries/email-signup-form-library';
import {isUserPremium} from '@Libraries/user.library';
import {useAppDispatch} from '@/hooks';
import {setIsSharedInTeam} from '@FormMakerReact/reducers/form-maker-publish-state-reducer';
import type {ShareInTeamRowProps} from './share-in-team-row.types';

export function ShareInTeamRow({idEmailSignupForm, isSharedInTeam, onUpsell}: ShareInTeamRowProps): ReactElement {
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const onStateUpdate = (next: ShareInTeamBarState): void => {
    if (next === ShareInTeamBarState.UPSELLING) {
      onUpsell();
      return;
    }
    const nextIsShared = next === ShareInTeamBarState.ACTIVE;
    void runShareToggle(idEmailSignupForm, nextIsShared, setIsLoading, (value) => {
      dispatch(setIsSharedInTeam(value));
    });
  };

  return <ShareInTeamToggleBar state={resolveShareInTeamBarState(isSharedInTeam)} isCurrentlyLoading={isLoading} onStateUpdate={onStateUpdate} />;
}

function resolveShareInTeamBarState(isSharedInTeam: boolean): ShareInTeamBarState {
  if (!isUserPremium()) {
    return ShareInTeamBarState.UPSELLING;
  }
  return isSharedInTeam ? ShareInTeamBarState.ACTIVE : ShareInTeamBarState.INACTIVE;
}

async function runShareToggle(
  idEmailSignupForm: string,
  nextIsShared: boolean,
  setIsLoading: (next: boolean) => void,
  setIsSharedInTeamState: (next: boolean) => void
): Promise<void> {
  setIsLoading(true);
  try {
    await shareEmailSignupFormInTeam(nextIsShared, idEmailSignupForm);
    setIsSharedInTeamState(nextIsShared);
  } finally {
    setIsLoading(false);
  }
}
